import Axios, { AxiosResponse } from "axios";

export function download(url: string, filename: string = ""): void {
  const splitUrl = url.split("/");
  if (!filename) filename = splitUrl[splitUrl.length - 1];

  Axios.get(url, { responseType: "blob" })
    .then((res: AxiosResponse) => {
      downloadBlob(res.data, filename);
    })
    .catch((e) => console.warn("Unable to download file!", e));
}

export function downloadBlob(data: Blob, filename: string): void {
  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

export function onScroll(querySelector: string, callback: any = null): void {
  const element = document.querySelector(querySelector);
  if (element)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.onscroll = function () {
      if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.scrollTop > this.scrollHeight - this.offsetHeight - 50 &&
        callback !== null
      )
        callback();
    };
}
export function isValidUrl(url: string): boolean {
  const urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return urlPattern.test(url);
}

export function randomColor(): string {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) color += letters[Math.floor(Math.random() * 16)];
  return color;
}

export function isEmail(value: string): boolean {
  return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value);
}

export function formDataAppend(
  formData: FormData,
  values: any = null,
  name: any = null
): FormData {
  if (!values && name) {
    formData.append(name, "");
  } else {
    if (typeof values === "object") {
      if (values?.lastModified) {
        formData.append(name, values);
      } else {
        for (const key in values) {
          if (typeof values[key] === "object") {
            formDataAppend(formData, values[key], `${name}[${key}]`);
          } else {
            formData.append(
              `${name}[${key}]`,
              typeof values[key] === "boolean"
                ? Number(values[key]).toString()
                : values[key]
            );
          }
        }
      }
    } else {
      formData.append(
        name,
        typeof values === "boolean" ? Number(values).toString() : values
      );
    }
  }
  return formData;
}

export function data2blob(data: string, mime: string) {
  data = data.split(",")[1];
  data = window.atob(data);
  const ia = new Uint8Array(data.length);
  for (let i = 0; i < data.length; i++) ia[i] = data.charCodeAt(i);
  return new Blob([ia], {
    type: mime,
  });
}
